export default Object.freeze({
	AdminHold: 'admin_hold',
	AdminHoldSelfRelease: 'admin_hold_self_release',
	Active: 'active',
	PendingClosure: 'pending_closure',
	AccountVerificationRequired: 'account_verification_required',
});
